import { Text } from '@fluentui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    GENERAL_FEEDBACK_EMPTY_HELPER,
    GENERAL_FEEDBACK_EMPTY_TITLE,
} from 'app/modules/newTicketView/generalFeedback';
import './NewTicketViewCards.scss';

/**
 * Replaces the per-customer cards on a General Feedback ticket, which by
 * definition has no customer attached. Rendered on the creator, admin and
 * viewer surfaces alike.
 */
const GeneralFeedbackEmptyState = ({ isVisible = true }: { isVisible?: boolean }) => {
    const { t: translate } = useTranslation();

    if (!isVisible) {
        return null;
    }

    return (
        <div className="general-feedback-empty-card" data-testid="general-feedback-empty-state">
            <div className="gf-empty-title">
                <Text>{translate(GENERAL_FEEDBACK_EMPTY_TITLE)}</Text>
            </div>
            <div className="gf-empty-helper">
                <Text>{translate(GENERAL_FEEDBACK_EMPTY_HELPER)}</Text>
            </div>
        </div>
    );
};

export default GeneralFeedbackEmptyState;
